const shallowMerge = (...args) => Object.assign({}, ...args);

export default shallowMerge;
